import React from 'react';
import 'twin.macro';

import { withFormik } from 'formik';
import * as Yup from 'yup';
import { navigate } from 'gatsby';

import addToMailchimp from 'gatsby-plugin-mailchimp';

import { Heading, Input, Button, Error, Container } from '../atoms';

const SubscribeForm = (props) => {
  const {
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    isSubmitting,
    errors,
    touched,
    description,
  } = props;
  return (
    <Container tw="bg-slate">
      <div tw="bg-green px-10 md:px-36 py-14">
        <Heading variant="base" tw="text-white mb-10">
          {description}
        </Heading>
        <form onSubmit={handleSubmit}>
          <div tw="flex flex-wrap mb-5">
            <div tw="w-full">
              <Input
                name="email"
                type="email"
                value={values.email}
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="Enter your email address"
              />
              <Error>
                {errors.email && touched.email ? errors.email : undefined}
              </Error>
            </div>
          </div>

          <Button
            type="submit"
            variant="secondary"
            disabled={isSubmitting}
            tw="md:w-3/12"
          >
            SIGN ME UP
          </Button>
        </form>
      </div>
    </Container>
  );
};

export default withFormik({
  mapPropsToValues: () => ({
    email: '',
  }),
  validationSchema: Yup.object().shape({
    email: Yup.string()
      .email('Invalid email address')
      .required('Email is required!'),
  }),
  handleSubmit: (values, { setSubmitting, resetForm }) => {
    addToMailchimp(values.email)
      .then((data) => {
        setSubmitting(false);
        resetForm();
        if (data?.result === 'success') {
          navigate('/thank-you/');
        }
      })
      .catch(() => {
        console.log('Already registered', 'error');
        setSubmitting(false);
      });
  },
  displayName: 'SubscribeForm', // helps with React DevTools
})(SubscribeForm);
